import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import EnglishDatePicker from '../../components/EnglishDatePicker/EnglishDatePicker';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://metro4.dcairo.com/api';

const PoursFlowUp = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  
  const [formData, setFormData] = useState({
    testType: 'Concrete',
    date: '',
    station: '',
    element: '',
    mixCode: 'C37/20 cem lll',
    customMixCode: '',
    totalQuantity: '',
    cubesCount: { groups: '', cubesPerGroup: '' },
    chemicals: '',
    esCubes: '',
    startTime: '',
    finishTime: '',
    batchPlant: ''
  });
  
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const allStations = [
    { value: 'ST13 Giza', label: 'ST13 Giza' },
    { value: 'ST14 Giza Square', label: 'ST14 Giza Square' },
    { value: 'S15 Alrawda', label: 'S15 Alrawda' },
    { value: 'ST16 Almalek Elsaleh', label: 'ST16 Almalek Elsaleh' },
    { value: 'ST17 Cut&Cover', label: 'ST17 Cut&Cover' },
    { value: 'Abo Rawash', label: 'Abo Rawash Lab' },
    { value: '4TL', label: '4TL Lab' }
  ];

  const batchPlants = ['Abo Rawash', 'Unimix', 'Green'];
  const mixCodes = [
    'C1 /slurry',
    'C20/20 opc',
    'C25/20 opc',
    'C37/20 cem lll',
    'C37/10 cem lll',
    'C37/20 cem lll mass',
    'C50/20 cem lll',
    'C50/10 cem lll',
    'Custom'
  ];
  const testTypes = ['Concrete', 'Trail', 'Grout'];

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCurrentUser(response.data.data.user);
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };
    fetchCurrentUser();
  }, []);

  const formatDateForAPI = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const calculateCubesSampleNo = () => {
    const { groups, cubesPerGroup } = formData.cubesCount;
    if (groups && cubesPerGroup) {
      return parseInt(groups) * parseInt(cubesPerGroup);
    }
    return 0;
  };

  const handleMixCodeChange = (value) => {
    setFormData({
      ...formData,
      mixCode: value,
      customMixCode: value === 'Custom' ? '' : ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const finalMixCode = formData.mixCode === 'Custom' ? formData.customMixCode : formData.mixCode;
      
      if (formData.mixCode === 'Custom' && !formData.customMixCode.trim()) {
        toast.error('الرجاء إدخال كود الخليط المخصص');
        setLoading(false);
        return;
      }
      
      const submitData = {
        testType: formData.testType,
        castingDate: formatDateForAPI(formData.date),
        station: formData.station,
        location: formData.element,
        mix: finalMixCode,
        quantity: formData.totalQuantity,
        cubesCount: formData.cubesCount,
        chemistry: formData.chemicals,
        esCubes: formData.esCubes || 0,
        startTime: formData.startTime,
        finishTime: formData.finishTime,
        batchPlant: formData.batchPlant
      };
      
      const response = await axios.post(`${API_URL}/pours`, submitData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        toast.success(response.data.message);
        setFormData({
          testType: 'Concrete',
          date: '',
          station: '',
          element: '',
          mixCode: 'C37/20 cem lll',
          customMixCode: '',
          totalQuantity: '',
          cubesCount: { groups: '', cubesPerGroup: '' },
          chemicals: '',
          esCubes: '',
          startTime: '',
          finishTime: '',
          batchPlant: ''
        });
      }
    } catch (error) {
      console.error('Error creating pour:', error);
      if (error.response?.data?.duplicate) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || 'Error adding pour');
      }
    } finally {
      setLoading(false);
    }
  };

  const cubesSampleNo = calculateCubesSampleNo();

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <h1>📝 إضافة صبة جديدة</h1>
        </div>

        <div className="dashboard-main">
          <style>{`
            .flowup-container {
              padding: 15px;
              max-width: 1200px;
              margin: 0 auto;
            }

            .flowup-card {
              background: white;
              border-radius: 20px;
              padding: 35px;
              box-shadow: 0 8px 30px rgba(0,0,0,0.08);
              border-top: 6px solid #f59e0b;
            }

            .card-header {
              text-align: center;
              margin-bottom: 35px;
              padding-bottom: 25px;
              border-bottom: 3px solid #f1f5f9;
            }

            .card-icon {
              font-size: 55px;
              margin-bottom: 15px;
              display: block;
            }

            .card-title {
              font-size: 32px;
              font-weight: 900;
              color: #1e293b;
              margin: 0;
              letter-spacing: -0.5px;
            }

            .card-subtitle {
              font-size: 15px;
              color: #64748b;
              margin-top: 8px;
              font-weight: 500;
            }

            .form-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
              gap: 25px;
              margin-bottom: 30px;
            }

            .form-group {
              display: flex;
              flex-direction: column;
              gap: 10px;
            }

            .form-group.full-width {
              grid-column: 1 / -1;
            }

            .form-label {
              font-size: 15px;
              font-weight: 700;
              color: #1e293b;
              display: flex;
              align-items: center;
              gap: 6px;
            }

            .required-star {
              color: #ef4444;
              font-size: 16px;
            }

            .form-input,
            .form-select {
              padding: 14px 16px;
              border: 2px solid #e2e8f0;
              border-radius: 12px;
              font-size: 15px;
              font-family: inherit;
              transition: all 0.3s;
              background: white;
            }

            .form-input:focus,
            .form-select:focus {
              outline: none;
              border-color: #f59e0b;
              box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);
              transform: translateY(-2px);
            }

            .form-input:hover,
            .form-select:hover {
              border-color: #cbd5e1;
            }

            .form-hint {
              font-size: 13px;
              color: #64748b;
              margin-top: 5px;
              display: flex;
              align-items: center;
              gap: 5px;
            }

            .custom-input-wrapper {
              animation: slideDown 0.3s ease;
            }

            @keyframes slideDown {
              from {
                opacity: 0;
                transform: translateY(-10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            .calculated-value {
              background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);
              border: 2px solid #3b82f6;
              padding: 14px 16px;
              border-radius: 12px;
              font-size: 16px;
              font-weight: 700;
              color: #1e40af;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              min-height: 52px;
            }

            .calculated-icon {
              font-size: 20px;
            }

            .form-actions {
              display: flex;
              gap: 15px;
              justify-content: center;
              padding-top: 25px;
              border-top: 3px solid #f1f5f9;
            }

            .btn-reset {
              padding: 16px 35px;
              background: #f1f5f9;
              color: #64748b;
              border: 2px solid #e2e8f0;
              border-radius: 12px;
              font-size: 16px;
              font-weight: 700;
              cursor: pointer;
              transition: all 0.3s;
              display: flex;
              align-items: center;
              gap: 8px;
            }

            .btn-reset:hover {
              background: #e2e8f0;
              border-color: #cbd5e1;
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            }

            .btn-submit {
              padding: 16px 45px;
              background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
              color: white;
              border: none;
              border-radius: 12px;
              font-size: 16px;
              font-weight: 700;
              cursor: pointer;
              transition: all 0.3s;
              box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);
              display: flex;
              align-items: center;
              gap: 8px;
            }

            .btn-submit:hover {
              transform: translateY(-3px);
              box-shadow: 0 8px 30px rgba(245, 158, 11, 0.5);
            }

            .btn-submit:active {
              transform: translateY(-1px);
            }

            .btn-submit:disabled {
              opacity: 0.6;
              cursor: not-allowed;
              transform: none;
            }

            .section-divider {
              grid-column: 1 / -1;
              height: 2px;
              background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
              margin: 10px 0;
            }

            .section-title {
              grid-column: 1 / -1;
              font-size: 18px;
              font-weight: 800;
              color: #1e293b;
              margin: 10px 0;
              padding: 12px 20px;
              background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
              border-radius: 12px;
              border-right: 5px solid #f59e0b;
              display: flex;
              align-items: center;
              gap: 10px;
            }

            @media (max-width: 768px) {
              .flowup-container {
                padding: 10px;
              }

              .flowup-card {
                padding: 20px;
                border-radius: 16px;
              }

              .card-icon {
                font-size: 45px;
              }

              .card-title {
                font-size: 24px;
              }

              .card-subtitle {
                font-size: 13px;
              }

              .form-grid {
                grid-template-columns: 1fr;
                gap: 20px;
              }

              .form-input,
              .form-select {
                padding: 12px 14px;
                font-size: 14px;
              }

              .form-actions {
                flex-direction: column;
              }

              .btn-reset,
              .btn-submit {
                width: 100%;
                justify-content: center;
                padding: 14px 25px;
              }

              .section-title {
                font-size: 16px;
                padding: 10px 15px;
              }
            }

            @media (max-width: 480px) {
              .card-title {
                font-size: 20px;
              }

              .form-label {
                font-size: 14px;
              }

              .calculated-value {
                font-size: 14px;
              }
            }
          `}</style>

          <div className="flowup-container">
            <div className="flowup-card">
              <div className="card-header">
                <span className="card-icon">📋</span>
                <h2 className="card-title">إضافة صبة جديدة</h2>
                <p className="card-subtitle">املأ جميع البيانات المطلوبة لإضافة الصبة</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="section-title">
                    <span>📊</span>
                    المعلومات الأساسية
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Test Type <span className="required-star">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={formData.testType}
                      onChange={(e) => setFormData({...formData, testType: e.target.value})}
                      required
                    >
                      {testTypes.map(tt => (
                        <option key={tt} value={tt}>{tt}</option>
                      ))}
                    </select>
                    <span className="form-hint">💡 نوع الاختبار</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Station <span className="required-star">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={formData.station}
                      onChange={(e) => setFormData({...formData, station: e.target.value})}
                      required
                    >
                      <option value="">اختر المحطة</option>
                      {allStations.map(st => (
                        <option key={st.value} value={st.value}>{st.label}</option>
                      ))}
                    </select>
                    <span className="form-hint">📍 المحطة</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Date <span className="required-star">*</span>
                    </label>
                    <EnglishDatePicker
                      selected={formData.date ? new Date(formData.date) : null}
                      onChange={(date) => setFormData({...formData, date: formatDateForAPI(date)})}
                      maxDate={new Date()}
                      placeholderText="Select Date"
                    />
                    <span className="form-hint">📅 تاريخ الصب (حسب وقت الانتهاء)</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Element <span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      value={formData.element}
                      onChange={(e) => setFormData({...formData, element: e.target.value})}
                      placeholder="e.g., D.W.S-(15)"
                      required
                    />
                    <span className="form-hint">🗂️ العنصر/الموقع</span>
                  </div>

                  <div className="section-divider"></div>

                  <div className="section-title">
                    <span>🔬</span>
                    المواصفات الفنية
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Mix Code <span className="required-star">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={formData.mixCode}
                      onChange={(e) => handleMixCodeChange(e.target.value)}
                      required
                    >
                      {mixCodes.map(m => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                    <span className="form-hint">🧪 كود الخليط</span>
                  </div>

                  {formData.mixCode === 'Custom' && (
                    <div className="form-group custom-input-wrapper">
                      <label className="form-label">
                        Custom Mix Code <span className="required-star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-input"
                        value={formData.customMixCode}
                        onChange={(e) => setFormData({...formData, customMixCode: e.target.value})}
                        placeholder="ادخل كود الخليط المخصص"
                        required
                      />
                      <span className="form-hint">✏️ اكتب الكود المخصص</span>
                    </div>
                  )}

                  <div className="form-group">
                    <label className="form-label">
                      Total Quantity <span className="required-star">*</span>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-input"
                      value={formData.totalQuantity}
                      onChange={(e) => setFormData({...formData, totalQuantity: e.target.value})}
                      placeholder="0.00"
                      required
                    />
                    <span className="form-hint">📦 الكمية الإجمالية (m³)</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Batch Plant <span className="required-star">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={formData.batchPlant}
                      onChange={(e) => setFormData({...formData, batchPlant: e.target.value})}
                      required
                    >
                      <option value="">اختر المصنع</option>
                      {batchPlants.map(bp => (
                        <option key={bp} value={bp}>{bp}</option>
                      ))}
                    </select>
                    <span className="form-hint">🏭 مصنع الخرسانة</span>
                  </div>

                  <div className="section-divider"></div>

                  <div className="section-title">
                    <span>🧊</span>
                    بيانات المكعبات
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Groups (G) <span className="required-star">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-input"
                      value={formData.cubesCount.groups}
                      onChange={(e) => setFormData({...formData, cubesCount: {...formData.cubesCount, groups: e.target.value}})}
                      placeholder="0"
                      required
                    />
                    <span className="form-hint">🔢 عدد المجموعات</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Cubes Per Group <span className="required-star">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-input"
                      value={formData.cubesCount.cubesPerGroup}
                      onChange={(e) => setFormData({...formData, cubesCount: {...formData.cubesCount, cubesPerGroup: e.target.value}})}
                      placeholder="0"
                      required
                    />
                    <span className="form-hint">🧱 عدد المكعبات في كل مجموعة</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Cubes Sample No <span style={{color: '#3b82f6', fontSize: '13px'}}>(محسوب تلقائياً)</span>
                    </label>
                    <div className="calculated-value">
                      <span className="calculated-icon">🧮</span>
                      {cubesSampleNo > 0 ? (
                        <span>{formData.cubesCount.groups}G × {formData.cubesCount.cubesPerGroup} = {cubesSampleNo}C</span>
                      ) : (
                        <span>- - -</span>
                      )}
                    </div>
                    <span className="form-hint">✨ إجمالي عدد المكعبات</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Chemicals (CH) <span className="required-star">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-input"
                      value={formData.chemicals}
                      onChange={(e) => setFormData({...formData, chemicals: e.target.value})}
                      placeholder="0"
                      required
                    />
                    <span className="form-hint">⚗️ عدد مكعبات الكيميا</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      E.S Cubes
                    </label>
                    <input
                      type="number"
                      className="form-input"
                      value={formData.esCubes}
                      onChange={(e) => setFormData({...formData, esCubes: e.target.value})}
                      placeholder="0"
                    />
                    <span className="form-hint">🔹 عدد مكعبات E.S</span>
                  </div>

                  <div className="section-divider"></div>

                  <div className="section-title">
                    <span>⏰</span>
                    أوقات الصب
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Time Start <span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      value={formData.startTime}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[0-9:]*$/.test(value) && value.length <= 5) {
                          setFormData({...formData, startTime: value});
                        }
                      }}
                      onBlur={(e) => {
                        let value = e.target.value.replace(/[^0-9]/g, '');
                        if (value.length >= 3) {
                          const hours = value.length === 3 ? value.substring(0, 1) : value.substring(0, 2);
                          const minutes = value.substring(value.length - 2);
                          const h = parseInt(hours);
                          const m = parseInt(minutes);
                          if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
                            setFormData({...formData, startTime: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`});
                          }
                        }
                      }}
                      placeholder="15:00"
                      maxLength="5"
                      required
                    />
                    <span className="form-hint">🕐 وقت البداية (مثال: 1500 أو 15:00)</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Time Finish <span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      value={formData.finishTime}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[0-9:]*$/.test(value) && value.length <= 5) {
                          setFormData({...formData, finishTime: value});
                        }
                      }}
                      onBlur={(e) => {
                        let value = e.target.value.replace(/[^0-9]/g, '');
                        if (value.length >= 3) {
                          const hours = value.length === 3 ? value.substring(0, 1) : value.substring(0, 2);
                          const minutes = value.substring(value.length - 2);
                          const h = parseInt(hours);
                          const m = parseInt(minutes);
                          if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
                            setFormData({...formData, finishTime: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`});
                          }
                        }
                      }}
                      placeholder="17:30"
                      maxLength="5"
                      required
                    />
                    <span className="form-hint">🕐 وقت النهاية (مثال: 1730 أو 17:30)</span>
                  </div>
                </div>

                <div className="form-actions">
                  <button 
                    type="button" 
                    className="btn-reset" 
                    onClick={() => {
                      setFormData({
                        testType: 'Concrete Pour',
                        date: '',
                        station: '',
                        element: '',
                        mixCode: 'C37/20 cem lll',
                        customMixCode: '',
                        totalQuantity: '',
                        cubesCount: { groups: '', cubesPerGroup: '' },
                        chemicals: '',
                        startTime: '',
                        finishTime: '',
                        batchPlant: ''
                      });
                    }}
                  >
                    <span>🔄</span>
                    إعادة تعيين
                  </button>
                  <button type="submit" className="btn-submit" disabled={loading}>
                    <span>{loading ? '⏳' : '✅'}</span>
                    {loading ? 'جاري الحفظ...' : 'حفظ الصبة'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoursFlowUp;